import { Col, Modal, Row, Tag, Select } from "antd";
import { DistrictFilter } from "./DistrictFilter";
import { MenuButton } from "../Menu/MenuButton";
import { useDispatch, useGlobal } from "reactn";
import { useHistory, useLocation } from "react-router-dom";
import { selectCategoryBySlug } from "state/categories/selectors";
import HpIcon, { Icons } from "react-hp-icons";
import React, { useEffect, useState } from "react";
import queryString from "query-string";

export const SearchFilter = () => {
	const history = useHistory();
	const location = useLocation();
	const [resultsUrl, setResultsUrl] = useState("");
	const [categories] = useGlobal("categories");
	const removeCategoryFilter = useDispatch("removeCategoryFilter");
	const addDistrictFilter = useDispatch("addDistrictFilter");
	const removeDistrictFilter = useDispatch("removeDistrictFilter");
	const addCategoryFilter = useDispatch("addCategoryFilter");

	const queryParams = queryString.parse(location.search);
	const { category: queryCategory, all: queryAll = false } = queryParams;

	const [openModal, setOpenModal] = useState(false);
	const [district, setDistrict] = useState("");

	const [search] = useGlobal("search");
	const { filters } = search;

	useEffect(() => {
		addCategoryFilter({ category: { slug: queryCategory } });
	}, [queryCategory]);

	const searchUrlShowAll = `/search?all=true`;
	const searchUrlByCategory = `/search?category=${search.category.slug}`;
	const searchUrlShowAllByDistrict = `/search?all=true&district=${district}`;
	const searchUrlByCategoryAndByDistrict = `/search?category=${search.category.slug}&district=${district}`;

	//const urlPath = `/search?${search.category.slug ? `category=${search.category.slug}` : ''}${district ? `district=${district}` : ''}`;
	/*

	if (location.pathname != urlPath)
	return <Redirect to=urlPath />
	*/

	const onCloseTag = (tagType) => {
		switch (tagType) {
			case "category":
				removeCategoryFilter().then(() => {
					if (filters.district) {
						setResultsUrl(searchUrlShowAllByDistrict);
					} else {
						setResultsUrl(searchUrlShowAll);
					}
				});
				break;
			case "district":
				removeDistrictFilter().then(() => {
					if (search.category.slug) {
						setResultsUrl(searchUrlByCategory);
					} else {
						setResultsUrl(searchUrlShowAll);
					}
				});
				break;
			default:
				break;
		}
	};

	useEffect(() => {
		resultsUrl && history.push(resultsUrl);
	}, [resultsUrl]);

	const handleModal = () => {
		setOpenModal((prevState) => !prevState);
	};

	const setFiltersAndResults = () => {
		handleModal();
		if (queryAll && district) {
			addDistrictFilter({ district }).then(() => {
				setResultsUrl(searchUrlShowAllByDistrict);
			});
		} else if (queryCategory && district) {
			addDistrictFilter({ district }).then(() => {
				setResultsUrl(searchUrlByCategoryAndByDistrict);
			});
		}
	};

	return (
		<Row style={{ marginTop: 12 }} align="middle">
			<Col>
				<MenuButton
					onClick={handleModal}
					menuButton={{
						icon: (
							<HpIcon
								type={Icons.filter}
								color="#fff"
								size={1.6}
							/>
						),
						text: "Filtros",
						type: "text",
						action: "openModal",
					}}
				></MenuButton>
				<Modal
					style={{ zIndex: 2 }}
					title="Filtros"
					visible={openModal}
					onCancel={handleModal}
					onOk={() => {
						// handleModal();
						// handleActionsByFilter();
						setFiltersAndResults();
					}}
					cancelText="Cancelar"
					okText="Aplicar filtro"
				>
					<h5>Filtrar por:</h5>
					<DistrictFilter
						setDistrict={setDistrict}
						districts={search.districts}
					></DistrictFilter>
				</Modal>
			</Col>
			{!!search.category.slug && (
				<Col>
					<Tag
						closable
						color="transparent"
						onClose={() => onCloseTag("category")}
						style={{ borderColor: "white" }}
					>
						{
							selectCategoryBySlug(
								categories,
								search.category.slug
							).name
						}
					</Tag>
				</Col>
			)}
			{!!filters.district && (
				<Col>
					<Tag
						closable
						color="transparent"
						onClose={() => onCloseTag("district")}
						style={{ borderColor: "white" }}
					>
						{filters.district}
					</Tag>
				</Col>
			)}
		</Row>
	);
};
